import React, { useEffect } from "react";
import { Input ,InputNumber} from "antd";
import FloatLabel from "../FloatingLabel";
import { CheckOutlined } from "@ant-design/icons";

function fmt(x, currency) {
  if (x && currency) {
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != '') lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return res;
  }
  return x;
}

const InputComponent = (props) => {
  const {
    item,
    field,
    form,
    placeholder,
    readOnly,
    keyboardType,
    autoFoucs,
    successTick,
  } = props;
  const { code } = item;
  const { value, name } = field;

  const { setFieldValue, handleBlur, handleChange, setFieldError, values } =
    form;

  useEffect(() => {
    if (code === "lastName" && values[744] !== undefined  && values?.[744].toLowerCase() === value?.toLowerCase() && value !== undefined) {
      setTimeout(() => {
        setFieldError(name, "Last Name should not be same as First Name");
      });
    }
  }, [value, code, values[744]]);

  if (code == "netIncome") {
    return (
      <FloatLabel label={placeholder} name={name} value={value}>
        <InputNumber
          maxLength={9}
          autoFocus={autoFoucs}
           controls={false}
           formatter={(value) => {
             return fmt(value, true);
           }}
          inputMode={keyboardType || "text"}
          size="large"
          readOnly={readOnly}
          style={{
            borderRadius: 6,
            backgroundColor: readOnly ? "#d9d9d9" : true,
          }}
          value={value || ""}
          name={name}
          onBlur={() => {
            handleBlur(name);
          }}
          onChange={(text) => {
           
            if (!readOnly) {
              setFieldValue(name, text);
            }
          }}
        />
      </FloatLabel>
    );
  }

  return (
    <FloatLabel label={placeholder} name={name} value={value}>
      <Input
        autoFocus={autoFoucs}
        inputMode={keyboardType || "text"}
        size="large"
        disabled={readOnly}
        style={{
          borderRadius: 6,
          // backgroundColor: readOnly ? "#d9d9d9" : true,
        }}
        value={value || ""}
        name={name}
        onBlur={() => {
          handleBlur(name);
        }}
        // onFocus={() => {
        //   setTouched(
        //     {
        //       ...touched,
        //       [name]: true,
        //     },
        //     true
        //   );
        // }}
        onChange={(e) => {
          handleChange(e);

          let text = e.target.value;
          if (
            code?.toLowerCase() === "PAN"?.toLowerCase() ||
            code?.toLowerCase() === "PanNumber"?.toLowerCase()
          ) {
            text = text.toUpperCase();
          }


          if (!readOnly) {
            setFieldValue(name, text);
          }
        }}
        suffix={
          successTick ? (
            <CheckOutlined style={{ color: "green", paddingRight: 10 }} />
          ) : null
        }
      />
    </FloatLabel>
  );
};

export default InputComponent;
